import React from 'react';
import { useParams } from 'react-router-dom';
import Feed from '../Feed/Feed2';
import Head from '../Helper/Head';

const UserProfile = () => {
  const { user } = useParams();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <section className="container mainSection">
      <Head title={user} />
      <br/>
      <Feed user={user} />
    </section>
  );
};

export default UserProfile;
